import React from 'react'
import InnerHtml from '../../components/innerHtml'

const LandingPage = ({html, css}) => {
  return (
    <div className='landing-page-content'>
      <style>{css}</style>
      <InnerHtml className='landing-page-body'>
        {html}
      </InnerHtml>
    </div>
  )
}

export default LandingPage



// WEBPACK FOOTER //
// ./client/pages/landing/landingPage.js